import { createSelector } from 'reselect'
import {
  getList,
  getFilter,
  getSort,
  getPagination,
  getQuery,
  getUploadList,
} from 'react-redux/selectors/asset'
import {
  getFilter as getGlobalFilter
} from 'react-redux/selectors/app'

export default createSelector(
  [ getList, getFilter, getSort, getPagination, getGlobalFilter, getQuery, getUploadList ],
  (list, filter, sort, pagination, globalFilter, query, uploadList) => {
    return Object.assign(
      {},
      list,
      sort,
      pagination,
      filter,
      query,
      uploadList,
      {
        globalFilter: globalFilter.filter
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/app/component/asset/selector.js